
















































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { GetUserList, PostAddDept, PutUserPaw, PatchEditUser } from "@/request/common";
import MainHeader from "@/components/main-header.vue";
import ZuzhiTree from "../../components/zuzhi-tree.vue";

@Component({
  components: {
    MainHeader,
    ZuzhiTree,
  },
})
export default class Name extends mixins(listMixin) {
  private data: any = [];
  private treeRefreshKey: number = 1;
  private deptDialogVisible: boolean = false;
  private deptForm: any = {
    name: "",
    key: "",
  };

  private searchInstitution(id: any) {
    this.filters["institution_id"] = id;
    this.search();
  }

  private goAdd() {
    this.$router.push({
      path: "/main/account/zhanghu-edit",
    });
  }

  private goDeviceManage() {
    this.$router.push({
      path: "/main/account/device-manage",
    });
  }

  private openAddDept() {
    this.deptForm = {
      name: "",
      key: "",
    };
    this.deptDialogVisible = true;
  }

  private saveDept() {
    if (!this.deptForm.name) {
      this.$message.warning("请输入机构名称");
      return;
    }
    const payload: any = {
      name: this.deptForm.name,
      status: true,
    };
    if (this.deptForm.key) {
      payload.key = this.deptForm.key;
    }
    if (this.filters.institution_id) {
      payload.parent = this.filters.institution_id;
    }

    const loading = this.$loading({
      lock: true,
      text: "保存中...",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });

    PostAddDept(this, payload, loading)
      .then(() => {
        loading.close();
        this.$message.success("新增机构成功");
        this.deptDialogVisible = false;
        this.treeRefreshKey += 1;
      })
      .catch(() => {
        loading.close();
      });
  }

  private goEdit(item: any) {
    if (!item.is_active) {
      this.$message.warning("该账户已禁用，不能编辑");
      return;
    }
    this.$router.push({
      path: "/main/account/zhanghu-edit",
      query: {
        id: item.id,
      },
    });
  }

  private resetPwd(item: any) {
    this.$confirm("确定要重置该账号的密码吗？", "重置密码", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      PutUserPaw(this, item.id, loading)
        .then(() => {
          loading.close();
          this.$message.success("重置成功");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }

  private jinyong(item: any) {
    this.$confirm("禁用后该账户不能进入该网站，确定要禁用吗？", "禁用", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        is_active: false,
      };
      PatchEditUser(this, item.id, params, loading)
        .then(() => {
          loading.close();
          this.$message.success("禁用成功");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }

  private qiyong(item: any) {
    this.$confirm("确定要启用该账户？", "启用", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        is_active: true,
      };
      PatchEditUser(this, item.id, params, loading)
        .then(() => {
          loading.close();
          this.$message.success("启用成功");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }

  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中...",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        search: this.filters.search,
        dept: this.filters.institution_id,
        page: this.filters.current_page,
      },
    };
    if (!this.filters.institution_id) {
      delete params.params.dept;
    }
    localStorage.setItem("accountFilter", JSON.stringify(this.filters));
    GetUserList(this, params)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total;
        this.ifShowEmpty = !(this.data.length > 0);
      })
      .catch(() => {
        loading.close();
      });
  }

  mounted() {
    if (localStorage.getItem("accountFilter")) {
      this.filters = JSON.parse(localStorage.getItem("accountFilter") as any);
    }
    this.getList();
  }
}
